import React from 'react';

const About = () => {
    return (
        <div className='relative overflow-hidden mb-12 md:mb-48'>
            <div className='container-custom py-0 text-right flex justify-end'>
                <p className='text-xl text-slate-900 md:text-4xl leading-relaxed  max-w-3xl'>
                    Bercastle is an <em className='text-[#456EF2]'>AI-first technology</em> agency specializing in artificial intelligence, media technology, and voice solutions. Our team of expert engineers and strategists builds scalable, production-ready AI systems.
                </p>
            </div>
        </div>
    );
};

export default About;
